import AssetsUnderAdvisements from "../../../assets/images/assets-under-advisement.png";
import OurClients from "../../../assets/images/our-clients.png";
import { useComponentInView } from "../../../hooks/useComponentInView";
import useOutputReportStore from "../../../store/OutputReport.store";

import "../staticPageReport.scss";

const StaticPageOne = () => {
  const { ref } = useComponentInView();

  const metadata = useOutputReportStore().metadata;
  const sectionMetadata = metadata?.FirmOverview || {};
  const { sectionKeyKebab } = sectionMetadata;

  if (!metadata?.Cover?.data) return null;

  return (
    <article
      ref={ref}
      id={`section-${sectionKeyKebab}`}
      className="static-page-report report-article"
    >
      <header className="section-title report-article__header">
        <h1>A platform that goes beyond for client</h1>
        <div className="section-title__sub">
          Providing a broad range of investment solutions to help our global
          client base meet their investment objectives.
        </div>
      </header>

      <div className="report-article__content">
        <section className="report-article__visual">
          <div className="card">
            <section className="card__section">
              <div className="static-page-report__card-content">
                <div className="static-page-report__card-images">
                  <img
                    src={AssetsUnderAdvisements}
                    alt="Asset Under Advisement, our people and our statics"
                  />
                </div>
                <div className="static-page-report__card-images">
                  <img src={OurClients} alt="Our clients" />
                </div>
              </div>
            </section>
          </div>
          <div className="static-page-report__footnote">
            Sources: 1. Allspring and affiliates. Figures are as of 30 Sep 2023,
            unless otherwise noted. Please note that the assets under advisement
            (AUA) figures provided include discretionary and non-discretionary
            assets and have been adjusted to eliminate any duplication of
            reporting among assets directed by multiple investment teams and
            includes $86B from Galliard Capital Management ($68B stable value;
            $17B fixed income). AUA includes non-discretionary assets that are
            not captured in Allspring's assets under management (AUM) figure of
            $491B which includes Galliard, an investment advisor that is not
            part of the Allspring trade name/GIPS firm. Numbers may not add up
            to the total presented due to rounding. 2. Cerulli's league table.
            <br />
            <p className="static-page-report__footnote-legal">
              For Investment Professional Use Only In One-On-One Presentation
              With Client
            </p>
          </div>
        </section>
      </div>
    </article>
  );
};

export default StaticPageOne;
